import '../header/header.css';
import { useNavigate, useSearchParams } from "react-router-dom";
import { getInitials, getSessionItem, setSessionItem } from "../helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket, faXmark, faKey, faCircleInfo, faPlus, faTrash, faEye, faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import { ConfirmationModal } from "../../components/confirmationModel/confirmatiommodel";
import { useContext, useEffect, useState } from "react";
import { checkTokenExpiration } from "../helper";
import { GlobalStateContext } from "../GlobalState";
import { useLocation } from "react-router-dom";
import { AUTH, DEFAULTSLACKAPP } from "../constants";
import { addSlackAppDetails, deleteSlackAppDetails, generateOAuthUrl, generateSASKey, getAllSlackAppDetails } from "../authServices";
import { ADMINACCOUNT, SLACKACCOUNT, TEAMSACCOUNT } from "../ApiConfig";
import { AppData } from "../interfaces";
import { BLOB_IMAGES } from "../../blobAssets";
import { decryptClientSecret } from '../clientSecretHelper';
const Header = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { setCurrentStep } = useContext(GlobalStateContext);
    const [migrationKey, setMigrationKey] = useState<string>('');
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [showAddAppPopUp, setShowAddAppPopUp] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [addNewApp, setAddNewApp] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState<string>("");
    const [itemSelected, setItemSelected] = useState(false);
    const [appDataList, setAppDataList] = useState<AppData[]>([DEFAULTSLACKAPP]);
    const [blobAccountName, setBlobAccountName] = useState<string>('');
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [finalAppDataList, setFinalAppDataList] = useState<AppData[]>([]);
    const [isBlobAccount, setIsBlobAccount] = useState<boolean>(false);
    const [error, setError] = useState<any>('')
    const [searchParams] = useSearchParams();
    const location = useLocation();
      
    const [values, setValues] = useState({
    appName: "",
    partitionKey: "",
    clientID: "",
    clientSecret: "",
    workspaceID:"",
    workspaceName:"",
  });
  const fields = [
    { label: "App Name", name: "appName" },
    { label: "App ID", name: "partitionKey" },
    { label: "Client ID", name: "clientID" },
    { label: "Client Secret", name: "clientSecret" },
  ];

    useEffect(() => {
        const enterpriseAccount = getSessionItem('isEnterpriseAccount')
        if (!enterpriseAccount && location.pathname !== "/dashboardchannel") {
            setIsBlobAccount(true);
            const blobAccount = getSessionItem('blobAccount');
            setBlobAccountName(blobAccount);
        }
        handleAllSlackAppDetails();
    }, [])
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const confirmAction = () => {
        sessionStorage.clear();
        setCurrentStep(AUTH.ADMINLOGIN)
        navigate('/');
    }
    const confirmDeleteAction=()=>{
  handleAddDeleteSlackAppDetails(true);
 setIsModalOpen(false)
    }
    const copyToClipboard = () => {
        navigator.clipboard.writeText(migrationKey).then(() => {
            alert('Migration Key copied to clipboard!');
        });
    };
    const handleAzureAccountLogin = async () => {
        try {
            setSessionItem('isGenerateSASKey', true);
            // const teamsLoginData =  getSessionItem('TeamLoginData');
            // const redirectURI= teamsLoginData?process.env.REACT_APP_DASHBOARD_REDIRECT_URI:SLACKACCOUNT.REDIRECT_URI;
            const oauthUrl = generateOAuthUrl(ADMINACCOUNT.CLIENT_ID, ADMINACCOUNT.RESPONSE_TYPE, TEAMSACCOUNT.SCOPES, TEAMSACCOUNT.PROMPT, SLACKACCOUNT.REDIRECT_URI);
            // if(oauthUrl)
            window.location.href = oauthUrl;
        }
        catch (error) {
            console.error('Error during login:', error);
        }
    }
    useEffect(() => {
        const code = searchParams.get('code');
        const isGenerateSASKey = getSessionItem('isGenerateSASKey');
        const error = searchParams.get('error');
        if (error && isGenerateSASKey) {
            setError(error);
            setShowPopup(true)
            return
        }
        if (code && isGenerateSASKey) {
            handleAzureAccount(code)
        }
    }, [searchParams]);

    const handleAzureAccount = async (loginCode: string) => {
        const bearerToken = getSessionItem('bearerToken')
        if (bearerToken !== '') {
            const token = bearerToken;
            const istokenValid = checkTokenExpiration(token);
            if (istokenValid) {
                try {
                    setIsLoading(true);
                    const storageAccountDetails = await generateSASKey(loginCode, bearerToken)
                    const response = await storageAccountDetails.json();
                    if (response) {
                        setMigrationKey(response.data);
                        setShowPopup(true)
                    }

                }

                catch (error: any) {
                    setError(error?.message?.length > 200 ? error.message.slice(0, 110) + '...' : error.message);
                    setShowPopup(true)
                }
                finally {
                    setSessionItem('isGenerateSASKey', false);
                    setIsLoading(false);
                }
            }
        }

    }
 
   const getParsedData = async ():Promise<any>=>{
            const bearerToken = getSessionItem('bearerToken')
            const adminData = getSessionItem('adminData');
            const parsedata = JSON.parse(adminData);
             if (bearerToken !== '') {
                    const token = bearerToken;
                    const istokenValid = checkTokenExpiration(token);
                    if (istokenValid) {
                      return parsedata
              }}

   }
    const handleAddDeleteSlackAppDetails = async (isDelete:boolean,appData?:AppData)=>{
            setIsLoading(true);
            try {
                 const parsedData=await getParsedData()
                    if(isDelete){
                    await deleteSlackAppDetails(parsedData,deleteItemId);
                    handleAllSlackAppDetails();
                    setError("");   
                    }
                    else{
                    appData && await addSlackAppDetails(parsedData,appData);
                    handleAllSlackAppDetails();
                    handleAddAppClose(); 
                    }
                     setTimeout(() => {
                       setIsLoading(false);
                      }, 2000);              
            }
            catch (error) {
                setError(error);  
                setIsLoading(false);   
            }
            finally {
      setErrors({});
  setValues({
    appName: "",
    partitionKey: "",
    clientID: "",
    clientSecret: "",
    workspaceID:"",
    workspaceName:""
  });
  setDeleteItemId("");
            }
    }
         const handleAllSlackAppDetails = async () => {
            setIsLoading(true);
            try {
                const parsedata=await getParsedData()
                       const users = await getAllSlackAppDetails(parsedata);
                                        const responseData = await users.json();
                                        var newApps: AppData[] = [];
                                        if (responseData?.data.length > 0) {
                                               newApps= responseData.data.map((item: any) => ({
                                                       appName: item.appName,
                                                       partitionKey: item.partitionKey,
                                                       clientID: item.clientID,
                                                       clientSecret: decryptClientSecret(item.clientSecret) || item.clientSecret,
                                                       workspaceID: item?.workspaceID ?? "" ,
                                                       workspaceName:item?.workspaceName ?? ""
                                          }));                                     
                                        }
                                        newApps.push(DEFAULTSLACKAPP);
                                        setAppDataList(newApps);
                                        setFinalAppDataList(newApps);
                                        setSessionItem("appDataList",newApps);
            }
            catch (error) {
                setError(error);  

            }
            finally {
                setIsLoading(false);
            }
    
        }
    const handleProfileClick = () => {
        setShowPopup(!showPopup);
        setMigrationKey('')
        setError('')

    }   
      const handleAddNewApp = () => {
        handleAllSlackAppDetails();
        setAddNewApp(!addNewApp);
        setError('')
        handleCloseSearch();
    }
     const handleCloseLog = () => {
       handleCloseSearch();
      setAddNewApp(!addNewApp);
    }
    const handleAddAppClose = () => {
      setShowAddAppPopUp(!showAddAppPopUp);
       setError("");
       setErrors({});
          setValues({
    appName: "",
    partitionKey: "",
    clientID: "",
    clientSecret: "",
    workspaceID:"",
    workspaceName:""
  });
       handleCloseSearch();
    }
       const handleAddAppClick = () => { 
        handleCloseSearch();
      setShowAddAppPopUp(!showAddAppPopUp);
      if(itemSelected==true)
        setItemSelected(!itemSelected);
    }
    const handleAddAppItemClick = () => {
   setError("")
  const fieldErrors = validateAllFields(values);
  setErrors(fieldErrors);
  if (Object.keys(fieldErrors).length === 0) {
    if(appDataList.length>0 && appDataList?.find((app:AppData)=>app.partitionKey==values.partitionKey||app.clientID==values.clientID)){
     setError(`The provided Client ID or App ID is already registered. Try using unique values.`);
         setValues({
    appName: "",
    partitionKey: "",
    clientID: "",
    clientSecret: "",
    workspaceID:"",
    workspaceName:""
  });
      return;
    }
    else{
   handleAddDeleteSlackAppDetails(false,values);
    }
 
  }
    }
   const handleCloseSearch = () => {
        setSearchTerm('')
    }
      useEffect(() => {
  const filteredApps = appDataList.filter((app: AppData) => {
    const search = searchTerm.toLowerCase();
    return (
      app.partitionKey.toLowerCase().includes(search) ||
      app.workspaceName.toLowerCase().includes(search) ||
      app.workspaceID.toLowerCase().includes(search) ||
      app.appName.toLowerCase().includes(search)
    );
  });
  setFinalAppDataList(filteredApps);
}, [searchTerm]);

    const handleViewItem=(app:AppData)=>{
     setValues({
    appName: app.appName,
    partitionKey: app.partitionKey,
    clientID: app.clientID,
    clientSecret: app.clientSecret,
    workspaceID:app.workspaceID,
    workspaceName:app.workspaceName
  });
     setError("")
       handleCloseSearch();
  if(itemSelected==false)
    setItemSelected(!itemSelected);
  setShowAddAppPopUp(!showAddAppPopUp);
    }
    const handleDeleteItem = (partitionKey: string) => {
  setDeleteItemId(partitionKey);
    handleCloseSearch();
  setIsModalOpen(true);
};
  const validateAllFields = (values: AppData): Record<string, string> => {
  const errors: Record<string, string> = {};
  const slackAppIdRegex = /^A[0-9A-Z]{9,11}$/;
  const clientIdRegex = /^\d+\.\d+$/;
  const slackAppNameRegex = /^.{1,35}$/;

  if (!values.appName.trim()) {
    errors.appName = "App Name is required.";
  }
   else if (!slackAppNameRegex.test(values.appName.trim())) {
    errors.appName = "App Name must be less than 36 characters";
  }

  if (!values.partitionKey.trim()) {
    errors.partitionKey = "App ID is required.";
  } else if (!slackAppIdRegex.test(values.partitionKey)) {
    errors.partitionKey = "App ID must be a valid Slack App ID ";
  }

  if (!values.clientID.trim()) {
    errors.clientID = "Client ID is required.";
  }
  else if(!clientIdRegex.test(values.clientID)){
    errors.clientID = "Client ID must be a valid Slack Client ID";
  }

  if (!values.clientSecret.trim()) {
    errors.clientSecret = "Client Secret is required.";
  }
  return errors;
};


      const handleAddAppChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setErrors({});
      setError("");
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };
    const adminData = getSessionItem('adminData');
    const parsedata = JSON.parse(adminData);
    var avatar = ""
    if (parsedata) {
        avatar = getInitials(parsedata.userName)
    }
    useEffect(() => {
        const bearerToken = getSessionItem('bearerToken')
        if (bearerToken) {
            const token = bearerToken;
            const istokenValid = checkTokenExpiration(token)
            if (!istokenValid) {
                sessionStorage.clear()
                navigate('/')
            }
        }
    })
    return (
        <>
            {isLoading && (
                <div className="spinner-container">
                    <img
                        src={BLOB_IMAGES.spinnerGif}
                        alt="Loading..."
                        className="spinner-gif"

                    />
                </div>
            )}
            <header>
                <div className="headercontent">
                    <img src={BLOB_IMAGES.saketa} alt="slack" className="saketaicon" />
                    <span className='saketatext'>Saketa</span>
                </div>
                <div className="migration-profile">
                    {isBlobAccount &&
                        <div className="migration" onClick={() => { handleProfileClick() }}>
                            <FontAwesomeIcon icon={faKey} />
                            <label>Key</label>
                        </div>
                    }
                      <div className="migration"  onClick={() => { handleAddNewApp() }}>
                        Slack Config
                        </div>
                    <div className="Profilelogo">
                        <span className="avatar" >{avatar} </span>
                        <span>{parsedata?.userName} </span>
                        <span><FontAwesomeIcon icon={faRightFromBracket} onClick={() => setIsModalOpen(true)} style={{ cursor: "pointer" }} /></span></div>
                </div>
            </header>


            {showPopup && (
                <div className='storage'>
                    <div className="token-popup">
                        <FontAwesomeIcon icon={faXmark} onClick={() => setShowPopup(false)} height={30} width={30} className="closeIcon" />
                        <div className="popup-line">
                            <label className="account-name"><label style={{fontWeight:600,fontSize:"13px"}}>Storage Account:</label> &nbsp; {blobAccountName}</label>
                        </div>
                        {migrationKey !== '' ? (
                            <div className="popup-line">
                                <div className="migration-container">
                                <label className="migration-title">Migration Key: </label> 
                                <span className="TooltipMigration">
                                        <FontAwesomeIcon icon={faCircleInfo} className="infoIcon" />
                                        <span className="tooltiptext-migration">Set up the SAS key in the migrator tool to enable the connection
                                        </span>
                                    </span>
                                    </div>
                                <div className="key-container">
                                    <label
                                        className="key-box"
                                        title={migrationKey}
                                    >
                                        {migrationKey}
                                    </label>
                                </div>

                                <button onClick={copyToClipboard} className="copy-btn" style={{marginLeft:0}}>
                                    Copy
                                </button>
                            </div>
                        ) : <button
                            onClick={handleAzureAccountLogin}
                            className="generate-token-btn"
                        >
                            Generate Token
                        </button>}

                        {error !== '' ? <div className="key-error-msg">{error}</div> : ''}
                    </div>
                </div>
            )
            }

            {addNewApp &&(
             <div className='storage'>
            <div className="addApp">
           
             <div className='slack-search-header'>
  <span className="slack-search-names">
    <div className="slack-app-search"> <img src={BLOB_IMAGES.searchIcon} alt={BLOB_IMAGES.dummyImage} height={16} width={16} className="add-app-search-icon" />
                                <div className="add-app-search-container"> <input type="text" placeholder="Search" className="add-search-input" value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                    }} />
                                    {searchTerm !== '' && <span onClick={handleCloseSearch} className="app-close" style={{paddingTop:0}}>
                                        <img src={BLOB_IMAGES.close} alt="close" />
                                    </span>}
                                </div>
                            </div>
 <span onClick={handleCloseLog} className="app-close">
    <img src={BLOB_IMAGES.close} alt="close" />
  </span>
 </span>
                    </div>                     
       <div className="app-table-container">
  <div className="app-table-header">
    <div className="app-cell app-name">App Name</div>
    <div className="app-cell app-id">App ID</div>
    <div className="app-cell workspace-id">Workspace ID</div>
    <div className="app-cell workspace-name">Workspace Name</div>
    <div className="app-cell actions">Actions</div>
  </div>

  <div className="app-table-body">
    {finalAppDataList.length === 0 ? (
      <div className="no-data">
          No apps to display
      </div>
    ) : (
      finalAppDataList.map((app) => (
<div   className={`app-row ${app.partitionKey === DEFAULTSLACKAPP.partitionKey ? "disabled-row" : ""}`} key={app.partitionKey}>
  <div className="app-cell app-name" title={app.appName}>{app.appName.length > 24 ? app.appName.slice(0, 24) + '...' : app.appName}</div>
  <div className="app-cell app-id">{app.partitionKey}</div>
  <div className="app-cell workspace-id">{app.workspaceID}</div>
  <div className="app-cell workspace-name" title={app.workspaceName}>{app.workspaceName.length > 30 ? app.workspaceName.slice(0, 30) + '...' : app.workspaceName}</div>
  <div className="app-cell actions">
    <div className="action-column">
      <FontAwesomeIcon icon={faEye} onClick={() => handleViewItem(app)}  className='view-delete'/>
      <FontAwesomeIcon icon={faTrash} onClick={() => handleDeleteItem(app.partitionKey)} className='view-delete' />
    </div>
  </div>
</div>

      ))
    )}
  </div>
</div>
        <div className="action-column" style={{paddingTop:10}}>
                <button className="app-fetch" onClick={handleAddAppClick}>Add</button>
        </div>
         {!showAddAppPopUp &&<div className="add-app-error-msg" title={error?.message ? error.message : error}>{error?.message ? error.message : error}</div>}
      </div>
             </div>
            )}

{showAddAppPopUp&& (
     <div className='storage'>
        <div className="add-slack-app" style={{width:"40rem"}}>
           <div className="add-app-search" > 
<div className="add-app-banner">
  <h2 className="add-app-title">Add Slack App</h2>
  <span onClick={handleAddAppClose} className="close" style={{color:"white"}}>
   <FontAwesomeIcon icon={faXmark} />
  </span>
</div>
</div> 
<>
                                      
<div className='add-app-container'>
 <div>
      {fields.map(({ label, name }) => (
  <div key={name} className="field-row">
    <label htmlFor={name} className="field-label">
     {label}: <span style={{color:"red"}}>*</span>
    </label>
    <div className='error-container'>
 <input
  id={name}
  name={name}
  type="text"
  value={values[name as keyof typeof values]}
  onChange={handleAddAppChange}
  className="field-input"
  title= {values[name as keyof typeof values]}
/>
<div style={{height:"0.8rem"}}>
 {errors[name] &&  (
          <div className="add-app-error-msg" style={{textAlign:"left"}}>
            {errors[name]}
          </div>
        )}
</div>
        </div>
  </div>
))}
    </div>                                
 </div>
  {!itemSelected&&<button className='add-app' onClick={handleAddAppItemClick}>Add</button>}
  {showAddAppPopUp && <div className="add-app-error-msg"title={error?.message ? error.message : error} style={{ marginBottom: "0.8rem"}}>{error?.message ? error.message : error}</div>}
  </>
        </div>
     </div>
)}
            <ConfirmationModal
                isOpen={isModalOpen}
                onClose={closeModal}
                onConfirm={deleteItemId!=""? confirmDeleteAction:confirmAction}
                message={deleteItemId!=""?'Once this app is deleted, any authentication emails linked to it will no longer be valid.':'Clicking on "Proceed" will log you out of your account.'} />

        </>
    )
}
export default Header;